import { useDispatch, useSelector } from 'react-redux';
import { setSelectedDevice, getDevices, getSelectedDevice } from '../../../state/ducks/ble/bleService';

const useDeviceSelector = () => {
    const dispatch = useDispatch();
    const devices = useSelector(getDevices);
    const selectedDevice = useSelector(getSelectedDevice);

    const onDeviceSelected = (deviceId) => {
        const device = devices.find(item => item.id === deviceId);
        dispatch(setSelectedDevice(device));
    }
    
    const onDeviceUnselected = (deviceId) => {
        if(selectedDevice?.id === deviceId) {
            dispatch(setSelectedDevice(null));
        }        
    };

    const onDeviceConnected = (deviceId) => {
            console.log(deviceId)
    };

    return { selectedDevice, onDeviceSelected, onDeviceUnselected, onDeviceConnected };
};

export default useDeviceSelector;